import axios from 'axios';
import authHeader from "@/service/auth-header";

class EmailCampaignService {

    async getCompanyEmailCampaigns(companyId) {
        return await axios.get(`/api/emailcampaign/${companyId}`, {headers: authHeader()})
    }

    async searchCompanyEmailCampaigns(companyId, name) {
        return await axios.get(`/api/emailcampaign/${companyId}/${name}`, {headers: authHeader()})
    }

    async getEmailCampaign(emailCampaignId) {
        return await axios.get(`/api/emailcampaign/specific/${emailCampaignId}`, {headers: authHeader()})
    }

    async createEmailCampaign(companyId, data) {
        return await axios.post(`/api/emailcampaign/${companyId}`, data, {headers: authHeader()});
    }

    async startEmailCampaign(companyId, data) {
        return await axios.post(`/api/emailcampaign/start/${companyId}`, data, {headers: authHeader()});
    }

    async updateEmailCampaign(emailCampaignId, data) {
        return await axios.put(`/api/emailcampaign/${emailCampaignId}`, data, {headers: authHeader()});
    }

    async deleteEmailCampaign(emailCampaignId) {
        return await axios.delete(`/api/emailcampaign/${emailCampaignId}`, {headers: authHeader()})
    }
}

export default new EmailCampaignService();
